import PlayerBadge from './PlayerBadge';

export * from './PlayerBadge';
export default PlayerBadge;
